module.exports = (__webpack_require__(24))(395);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/antd/es/index.js from dll-reference lib_core
// module id = 2
// module chunks = 106